<ng-container *ngIf="statisticsData.length || !firstStatisticsFetch; else noData">
  <div class="tiles-container" *ngIf="tilesData.length">
    <app-statistics-tiles [tilesLoading]="tilesLoading" [title]="title" [getTilesData]="tilesData" [tilesCompareData]="tilesCompareData">
    </app-statistics-tiles>
  </div>
  <app-statistics-graphs
    *ngIf="!widgetMode"
    [graphFilterOptions]="graphFilterOptions"
    [title]="title"
    [mapData]="mapData"
    [mapCompareData]="mapCompareData"
    [graphAndMapContainerTitle]="graphAndMapContainerTitle"
    [graphAndMapContainerTotalElements]="graphAndMapContainerTotalElements"
    [graphAndMapContainerHeaderIcon]="graphAndMapContainerHeaderIcon"></app-statistics-graphs>
  <app-statistics-table
    [widgetMode]="widgetMode"
    [paramToCompare]="paramToCompare"
    [statisticsData]="statisticsData"
    [filterMenuOptions]="filterMenuOptions"
    [appliedFiltersBar]="appliedFiltersBar"
    [statisticsCompareData]="statisticsCompareData"
    [datesDifference]="datesDifference"
    [compareToCurrentDatesDifference]="compareToCurrentDatesDifference"
    [title]="title"
    [isExpandable]="true"
    [pagination]="pagination"
    [page]="page"
    [pageSize]="pageSize"
    [inputPage]="inputPage"
    [sortDropdownValues]="dropdownValues"
    [columnManagementOptions]="options"
    [loadTableDataOnPageChange]="loadTableDataOnPageChange"
    [defaultVisibleColumns]="defaultVisibleColumns"
    (emitPageChange)="pageChange($event)"
    (emitItemsPerPage)="itemsPerPageChange($event)">
  </app-statistics-table>
</ng-container>
<ng-template #noData>
  <div class="noData-wrapper">
    <p>{{ 'view_translations.no_results' | translate }}</p>
  </div>
</ng-template>
